/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetCities200, GetCities400, GetCitiesQueryResponse } from '../entities/GetCities'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { cityModelSchema } from './cityModelSchema'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const getCities200Schema = z.array(z.lazy(() => cityModelSchema)) as unknown as ToZod<GetCities200>

/**
 * @description Bad Request
 */
export const getCities400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetCities400>

export const getCitiesQueryResponseSchema = z.lazy(() => getCities200Schema) as unknown as ToZod<GetCitiesQueryResponse>